module.exports = "pegasus/assets/one-column-button-preview.png";